import type { CORNERS, FIXED_INDENTS, SHADOW } from 'vars/index'

import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { TextBoxSC } from 'atoms/TextBox'
import { PopupHeaderSC } from 'blocks/Popup/Popup.styled'
import { COLOR, LAYOUT, MEDIA } from 'vars/index'
import { SidebarPositions } from './SidebarComponent.h'

export const SidebarComponentSC = styled.div<{
  isOpen?: boolean
  width?: string
  backgroundColor?: COLOR
  position?: SidebarPositions
  shadow?: SHADOW
  horizontalPaddings?: LAYOUT | FIXED_INDENTS
  corners?: CORNERS
}>`
  --sidebarWidth: 100%;
  --topPosition: 0;
  ${MEDIA.MIN_600} {
    --sidebarWidth: ${({ width = '480px' }) => width};
    --topPosition: var(${LAYOUT.NavbarSize});
  }
  --paddingHeaderBlock: 28px;
  --paddingHeaderInline: 16px;
  --posterSize: 56px;
  position: fixed;
  z-index: 7;
  width: var(--sidebarWidth);
  top: var(--topPosition);
  bottom: 0;
  border-radius: ${({ corners }) => `var(${corners})`};

  right: ${({ position }) =>
    position === SidebarPositions.Right ? 0 : 'initial'};
  left: ${({ position }) =>
    position === SidebarPositions.Left ? 0 : 'initial'};

  background-color: ${({ backgroundColor = COLOR.BACKGROUND_DARK }) =>
    `var(${backgroundColor})`};
  box-shadow: ${({ isOpen, shadow }) =>
    isOpen && shadow ? `var(${shadow})` : 'none'};
  display: flex;
  flex-direction: column;

  ${PopupHeaderSC} {
    background-color: var(${COLOR.OVERLAY_DEFAULT});
    display: flex;
    align-items: center;
    column-gap: 16px;
    padding: var(--paddingHeaderBlock) var(--paddingHeaderInline);
    flex: 0 0 auto;
    ${ButtonSC} {
      position: relative;
      top: unset;
      right: unset;
    }
    ${TextBoxSC} {
      flex: 1;
    }
  }
`
